import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, Printer, Loader2 } from "lucide-react";
import { SituationReport } from "../../components/joe/SituationReport";
import { api } from "../../lib/api";

export default function ReportPage() {
  const nav = useNavigate();
  const [r, setR] = useState(null);
  useEffect(() => { api.get("/case/report").then(({ data }) => setR(data)).catch(() => nav("/login")); }, [nav]);
  if (!r) return <div className="grid min-h-screen place-items-center"><Loader2 className="h-8 w-8 animate-spin" /></div>;
  return (
    <div className="mx-auto max-w-4xl px-4 py-6">
      <div className="no-print mb-4 flex justify-between">
        <button data-testid="report-back-btn" onClick={() => nav("/case")} className="inline-flex items-center gap-2 font-semibold"><ArrowLeft className="h-4 w-4" /> Back to my case</button>
        <button data-testid="report-print-btn" onClick={() => window.print()} className="tap inline-flex h-11 items-center gap-2 rounded-xl bg-slate-900 px-4 font-bold uppercase text-white"><Printer className="h-4 w-4" /> Download / Print</button>
      </div>
      <SituationReport r={r} />
    </div>
  );
}
